import { Injectable } from '@angular/core';
import { Constants } from 'src/app/shared/utilities/constants';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  loginLogout: BehaviorSubject<string> = new BehaviorSubject<string>('');

  getItem(key: string) {
    return localStorage.getItem(key);
  }

  getAccessToken() {
    return this.getItem(Constants.STORAGE_KEYS.ID_TOKEN);
  }

  setItem(key: string, value: any) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      console.error('Error while setting item in localStorage:', e);
      return false;
    }
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }

  isLoggedIn() {
    return !!this.getAccessToken();
  }

  isEnabled() {
    try {
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');
      return true;
    } catch (e) {
      console.error('Error while setting item in localStorage:', e);
      return false;
    }
  }

  getKey(key: string) {
    try {
      const storedKey = localStorage.getItem(key);
      if (storedKey) {
        return atob(JSON.parse(storedKey));
      }
    } catch (e) {
      console.error('Error while decoding the Key', e);
    }
    return '';
  }

  getParsedItem(key: string) {
    const item = this.getItem(key);
    if (item) {
      try {
        return JSON.parse(item);
      } catch (e) {
        console.error('Error while parsing item from localStorage:', e);
      }
    }
    return null;
  }

  setSessionItem(key: string, value: any) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      console.error('Error while setting item in sessionStorage:', e);
      return false;
    }
  }

  getSessionItem(key: string) {
    return sessionStorage.getItem(key);
  }

  removeSessionItem(key: string) {
    sessionStorage.removeItem(key);
  }

  clearSession() {
    sessionStorage.clear();
  }

  getParsedSessionItem(key: string) {
    const item = this.getSessionItem(key);
    if (item) {
      try {
        return JSON.parse(item);
      } catch (e) {
        console.error('Error while parsing item from sessionStorage:', e);
      }
    }
    return null;
  }
}
